import { render, staticRenderFns } from "./AccordionSubItemAlgoServer.vue?vue&type=template&id=2ec9a65f&scoped=true"
import script from "./AccordionSubItemAlgoServer.vue?vue&type=script&lang=js"
export * from "./AccordionSubItemAlgoServer.vue?vue&type=script&lang=js"
import style0 from "./AccordionSubItemAlgoServer.vue?vue&type=style&index=0&id=2ec9a65f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9a65f",
  null
  
)

export default component.exports